import { BranchKey, EnvironmentId, IdentityId } from "../../storage/appState/types";

export interface AavoHeaders {
	"X-aavo-branch": BranchKey;
	"X-aavo-identity": IdentityId;
	"X-env-association-id": EnvironmentId;
}

export const constructAavoHeaders = (
	branch: BranchKey,
	identity: IdentityId,
	environment: EnvironmentId
): Partial<AavoHeaders> => {
	const headers: AavoHeaders = {
		"X-aavo-branch": branch,
		"X-aavo-identity": identity,
		"X-env-association-id": environment,
	};
	return filterNullHeaders(headers);
};

function filterNullHeaders(headers: AavoHeaders): Partial<AavoHeaders> {
	const filteredHeaders: Partial<AavoHeaders> = {};
	Object.entries(headers).forEach(([key, value]) => {
		if (value !== null) {
			filteredHeaders[key as keyof AavoHeaders] = value;
		}
	});
	return filteredHeaders;
}
